/**
 * Utilitários para máscaras de formulários
 */

/**
 * Aplica máscara de CEP (00000-000)
 */
export const applyCepMask = (value: string): string => {
  let cleanValue = value.replace(/\D/g, "");

  if (cleanValue.length > 8) {
    cleanValue = cleanValue.slice(0, 8);
  }

  if (cleanValue.length > 5) {
    return cleanValue.slice(0, 5) + "-" + cleanValue.slice(5);
  }

  return cleanValue;
};

/**
 * Aplica máscara de telefone/celular
 * (00) 0000-0000 ou (00) 00000-0000
 */
export const applyPhoneMask = (value: string): string => {
  let cleanValue = value.replace(/\D/g, "");

  if (cleanValue.length > 11) {
    cleanValue = cleanValue.slice(0, 11);
  }

  if (cleanValue.length <= 10) {
    // Telefone fixo: (00) 0000-0000
    if (cleanValue.length > 6) {
      return `(${cleanValue.slice(0, 2)}) ${cleanValue.slice(
        2,
        6
      )}-${cleanValue.slice(6)}`;
    } else if (cleanValue.length > 2) {
      return `(${cleanValue.slice(0, 2)}) ${cleanValue.slice(2)}`;
    } else if (cleanValue.length > 0) {
      return `(${cleanValue}`;
    }
  } else {
    // Celular: (00) 00000-0000
    return `(${cleanValue.slice(0, 2)}) ${cleanValue.slice(
      2,
      7
    )}-${cleanValue.slice(7)}`;
  }

  return cleanValue;
};

/**
 * Aplica máscara de CNPJ (00.000.000/0000-00)
 */
export const applyCnpjMask = (value: string): string => {
  let cleanValue = value.replace(/\D/g, "");

  if (cleanValue.length > 14) {
    cleanValue = cleanValue.slice(0, 14);
  }

  if (cleanValue.length > 12) {
    return `${cleanValue.slice(0, 2)}.${cleanValue.slice(
      2,
      5
    )}.${cleanValue.slice(5, 8)}/${cleanValue.slice(8, 12)}-${cleanValue.slice(
      12
    )}`;
  } else if (cleanValue.length > 8) {
    return `${cleanValue.slice(0, 2)}.${cleanValue.slice(
      2,
      5
    )}.${cleanValue.slice(5, 8)}/${cleanValue.slice(8)}`;
  } else if (cleanValue.length > 5) {
    return `${cleanValue.slice(0, 2)}.${cleanValue.slice(
      2,
      5
    )}.${cleanValue.slice(5)}`;
  } else if (cleanValue.length > 2) {
    return `${cleanValue.slice(0, 2)}.${cleanValue.slice(2)}`;
  }

  return cleanValue;
};

/**
 * Aplica máscara de CPF (000.000.000-00)
 */
export const applyCpfMask = (value: string): string => {
  let cleanValue = value.replace(/\D/g, "");

  if (cleanValue.length > 11) {
    cleanValue = cleanValue.slice(0, 11);
  }

  if (cleanValue.length > 9) {
    return `${cleanValue.slice(0, 3)}.${cleanValue.slice(
      3,
      6
    )}.${cleanValue.slice(6, 9)}-${cleanValue.slice(9)}`;
  } else if (cleanValue.length > 6) {
    return `${cleanValue.slice(0, 3)}.${cleanValue.slice(
      3,
      6
    )}.${cleanValue.slice(6)}`;
  } else if (cleanValue.length > 3) {
    return `${cleanValue.slice(0, 3)}.${cleanValue.slice(3)}`;
  }

  return cleanValue;
};

/**
 * Remove todos os caracteres não numéricos
 */
export const removeNonNumeric = (value: string): string => {
  return value.replace(/\D/g, "");
};
